import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true, // expose --v-primary-base etc for custom CSS
    },
    themes: {
      light: {
        // Keep existing primary to avoid breaking pages that rely on the default blue,
        // then tune the rest of the palette for a more modern, calmer UI.
        primary: '#1976d2',
        secondary: '#0f172a',
        accent: '#0ea5a6',
        error: '#ef4444',
        warning: '#f59e0b',
        info: '#0ea5e9',
        success: '#16a34a',
        background: '#eef2f7',
      },
    },
  },
});
